/* ============================================
   SECTION SLIDESHOW — section-slideshow.js
   ============================================ */

(function () {
  'use strict';

  class Slideshow {
    constructor(el) {
      this.el = el;
      this.slides = Array.from(el.querySelectorAll('.slideshow__slide'));
      this.navItems = Array.from(el.querySelectorAll('.slideshow__nav-item'));
      this.prevBtn = el.querySelector('.slideshow__arrow--prev');
      this.nextBtn = el.querySelector('.slideshow__arrow--next');

      this.current = 0;
      this.total = this.slides.length;
      this.delay = parseInt(el.dataset.autoplayDelay, 10) || 7000;
      this.timer = null;
      this.isAnimating = false;

      if (this.total < 2) return; // nothing to do for single slide

      this.bindEvents();
      this.startAutoplay();
    }

    goTo(index) {
      if (this.isAnimating || index === this.current) return;
      this.isAnimating = true;

      const prev = this.current;
      this.current = (index + this.total) % this.total;

      // Swap active slide
      this.slides[prev].classList.remove('is-active');
      this.slides[this.current].classList.add('is-active');

      // Sync nav
      if (this.navItems.length) {
        this.navItems[prev]?.classList.remove('is-active');
        this.navItems[prev]?.setAttribute('aria-selected', 'false');
        this.navItems[this.current]?.classList.add('is-active');
        this.navItems[this.current]?.setAttribute('aria-selected', 'true');
      }

      // Allow next transition after CSS duration
      setTimeout(() => { this.isAnimating = false; }, 900);
    }

    next() {
      this.goTo(this.current + 1);
    }

    prev() {
      this.goTo(this.current - 1);
    }

    startAutoplay() {
      this.stopAutoplay();
      this.timer = setInterval(() => this.next(), this.delay);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    bindEvents() {
      // Arrow buttons
      this.prevBtn?.addEventListener('click', () => {
        this.prev();
        this.startAutoplay();
      });

      this.nextBtn?.addEventListener('click', () => {
        this.next();
        this.startAutoplay();
      });

      // Nav dots / bars
      this.navItems.forEach((item, i) => {
        item.addEventListener('click', () => {
          this.goTo(i);
          this.startAutoplay();
        });
      });

      // Pause on hover
      this.el.addEventListener('mouseenter', () => this.stopAutoplay());
      this.el.addEventListener('mouseleave', () => this.startAutoplay());

      // Touch / swipe support
      let touchStartX = 0;
      let touchStartY = 0;

      this.el.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
      }, { passive: true });

      this.el.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].screenX - touchStartX;
        const dy = e.changedTouches[0].screenY - touchStartY;

        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
          dx < 0 ? this.next() : this.prev();
          this.startAutoplay();
        }
      }, { passive: true });

      // Keyboard nav when focused
      this.el.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft')  { this.prev(); this.startAutoplay(); }
        if (e.key === 'ArrowRight') { this.next(); this.startAutoplay(); }
      });

      // Shopify theme editor: respond to block:select
      document.addEventListener('shopify:block:select', (e) => {
        const blockEl = e.target.closest('.slideshow__slide');
        if (!blockEl) return;
        const idx = this.slides.indexOf(blockEl);
        if (idx > -1) {
          this.stopAutoplay();
          this.goTo(idx);
        }
      });

      document.addEventListener('shopify:block:deselect', () => {
        this.startAutoplay();
      });
    }
  }

  // Init all slideshows on the page
  function initSlideshows() {
    document.querySelectorAll('.section--slideshow-wrapper').forEach((el) => {
      if (!el.dataset.slideshowInit) {
        el.dataset.slideshowInit = 'true';
        new Slideshow(el);
      }
    });
  }

  // DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlideshows);
  } else {
    initSlideshows();
  }

  // Shopify theme editor re-init
  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target.querySelector('.section--slideshow-wrapper');
    if (el) {
      delete el.dataset.slideshowInit;
      new Slideshow(el);
    }
  });
})();